import { AnyObject, InputSize } from '@hb/shared'
import React from 'react'

export type Theme = 'basic' | 'detailed'

export interface ThemeContextData<TooltipProps extends AnyObject = AnyObject> {
  theme?: Theme
  /** Form-wide input size, carried through context so inputs can resolve it without prop-drilling. */
  inputSize?: InputSize
  hideLabels?: boolean
  hideHints?: boolean
  hideInfo?: boolean
  tooltipError?: boolean
  tooltipErrorPlacement?: 'top' | 'bottom' | 'left' | 'right'
  placeholderAbove?: boolean
  errorTooltipProps?: Partial<TooltipProps>
}

export const ThemeContext = React.createContext<ThemeContextData<any>>({
  theme: undefined,
  hideLabels: false,
  hideInfo: false,
  hideHints: false,
  tooltipError: false,
  placeholderAbove: false,
})
